
import styled from "styled-components";
import React from "react";
import { Route, Link, Redirect } from "react-router-dom";
import steeltoe from 'steeltoe'
import PreviousMeetings from "./Previous/PreviousMeetings";
import PrivateRoute from "../../../Routes/PrivateRoute";
import { Tabs, Tab } from "../../Elements/Tabs";
import UpcomingMeetings from "./Previous/UpcomingMeetings";
import Breadcrumbs from "../../Elements/Breadcrumbs";
import FormRow from "../../Elements/FormRow";
import Input from "../../Elements/Input";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useState } from "react";
import Button from "../../Elements/Button";
import { useForm } from "react-hook-form";
import { auth, db } from "../../../config/firebase";
import moment from 'moment';
import { useEffect } from "react";


const Alert = styled.div`
    padding: 6px 8px;
    border: 1px solid red;
    border-radius: 6px;
`


const Content_ = ({className}) => {
    const minDate =  moment().second() ||  moment().millisecond() ?  moment().add(1, 'hour').startOf('hour') : null;

    // const [startDate, setStartDate] = useState(new Date());
    const [startDate, setStartDate] = useState(minDate.toDate());
    const { register, handleSubmit, watch, errors } = useForm();
    const [firebaseResult, setFirebaseResult] = useState(null);

    const [user, setUser] = useState(null);
    const [account, setAccount] = useState(null);
    useEffect(()=>{
        console.log(auth.currentUser.email)
        db.collection('users').doc(auth.currentUser.email).get()
            .then(snap => {
                const user = snap.data();
                console.log(user);
                setUser(user);
                
                
                db.collection('accounts').doc(user.accountId).get()
                .then(snap=>{
                    const account = snap.data();
                    console.log('account:', account);
                    setAccount(account);

                    })
                    .catch(err => {

                        console.log('err getting account', err)
                    })

                
            })
            .catch(err=>{
                console.log('err gettin user', err)
            });
    },[]);

    if(!user || !account) {
        return null;
    }

    const IdentifyUser = {
        id: auth.currentUser.uid,
        email: auth.currentUser.email,
    }

    const isPendo = true;
    let IdentifyAccount = null;

    // PX
    if (isPendo) {
        IdentifyAccount = {
            id: account.id,
            accountId: account.id,
        }

        console.log("user Profile",IdentifyUser);
        console.log("account Profile",IdentifyAccount);

        window.pendo.initialize({
            visitor: IdentifyUser,
            account: IdentifyAccount
        });

    } else {
        IdentifyAccount = {
            accountId: account.id,
        }

        console.log("user Profile",IdentifyUser);
        console.log("account Profile",IdentifyAccount);

        // PX
        window.aptrinsic("identify",
            IdentifyUser,
            IdentifyAccount
        );
    }
    

    const onSubmit = (data) => {
        const { topic } = data;
        console.log('onSubmit', data);


        window.aptrinsic("track","Admin-Call-Settings",{"message":data.welcome,"url":data.topic});

        // const randMeetingId = Math.floor(1000000000 + Math.random() * 9000000000);
        
        // const sendData = {
        //     uid:auth.currentUser.uid,
        //     topic,
        //     meetingDate: startDate,
        //     meetingId: randMeetingId
        // }


        // console.log('sendData', sendData);

        // db.collection('meetings').add(sendData)
        //     .then(snap => {
        //         console.log('Meeting created');
        //         setFirebaseResult({ type:'success' });

        //     }).catch( err => {
        //         console.log('Error creating meeting', err)
        //         setFirebaseResult({ type:'error', message: err.message });
        //     })
        
    }

    // if(firebaseResult&&firebaseResult.type==='success'){
    //     return <Redirect to="/meeting" />
    // }




    return (
        <div className={className}>

            <Breadcrumbs path={[
                // { name: 'Admin', to: "/meeting"},
                { name: 'Admin'},
                { name: 'Virtual Background'}
            ]}/>

            <h3>Virtual Background Settings</h3>

            <form onSubmit={handleSubmit(onSubmit)}>

                {firebaseResult && <Alert {...firebaseResult}>{firebaseResult.message}</Alert>}

                

                <FormRow>
                    <div>Name</div>
                    <div><Input name="welcome" placeholder="Name" 
                        // inputRef={register}
                        // inputRef={register({
                        //     validate: value => value ? true : 'Welcome Message'
                        // })}
                        invalid={!!steeltoe(errors).get('welcome.message')}
                        message={steeltoe(errors).get('welcome.message')}
                    /> 
                    </div>

                    
                </FormRow>
                <FormRow>
                    <div>Image URL</div>
                    <div><Input name="topic" placeholder="Image URL" 
                        // inputRef={register}
                        // inputRef={register({
                        //     validate: value => value ? true : 'Enter URL'
                        // })}
                        invalid={!!steeltoe(errors).get('topic.message')}
                        message={steeltoe(errors).get('topic.message')}
                    /> 
                    </div>

                    
                </FormRow>

                {/* <FormRow>
                    <div>Other Default</div>
                    <div>
                        <ReactDatePicker selected={startDate} onChange={date => setStartDate(date)} showTimeSelect 
                            // minDate={new Date()}  
                            minDate={minDate}  
                            timeFormat="HH:mm"
                            timeIntervals={15}
                            timeCaption="time"
                            dateFormat="MMMM d, yyyy h:mm aa"
                        />
                    </div>
                </FormRow> */}

                <FormRow style={{
                    marginTop: 24,
                    paddingTop: 24,
                    borderTop: '1px solid #eeeff2'
                }}>
                    <div></div>
                    <div>
                        <Button id="virtual-background-cancel" style={{width:"auto", padding: '6px 27px'}} secondary to="/meeting">Cancel</Button>
                        <Button id="virtual-background--save" style={{width:"auto", padding: '6px 27px'}} type="submit">Save</Button>
                        {/* <input style={{width:"auto", padding: '6px 27px'}} type="submit"></input> */}

                    </div>
                </FormRow>
            </form>

            
        </div>
    )
}

const Content = styled(Content_)`
    margin: 20px;
    p {
        margin: 0;
    }
    .right {
        text-align: right;
        padding: 10px 20px;
    }
    
`

export default Content

// import styled from "styled-components";
// import React from "react";
// import { Route, Link } from "react-router-dom";


// const Content_ = ({className}) => {
//     return (
//         <div className={className}>
//             <p>
//                 What is a Theme?
//             </p>
//             <ul>
//                 <li>
//                     Face2Face Admin Themesallow you to easily conduct large online events with video, audio and screen sharing for up to 100 video participants and 10,000 attendees
//                 </li>
//                 <li>
//                     The features in Webinar are tailored for managing large audiences with branding, registration, host controls, polls, question & answer, raise hand, chat, recording and reporting
//                 </li>
//                 <li>
//                     Monetize your webinars with our Paypal integration (via Zapier)
//                 </li>
//             </ul>
//             <p>
//                 How do we set up a Theme?
//             </p>
//             <ul>
//                 <li>
//                     Webinar can be added to any paid plans such as Pro, Business or Edu
//                 </li>
//                 <li>
//                     Go to your Webinar Add-On Plan, or contact your sales representative
//                 </li>
//             </ul>
//             <p>
//                 How do I start?
//             </p>
//             <ul>
//                 <li>
//                     Click <Link id="webinars-learn-more-link" to="/webinars-more">here</Link> to contact a member from our sales team.
//                     {/* On the User Management page, admin can enable Webinars for certain users with Edit User */}
//                 </li>
//             </ul>

//             <div className="right">
//                 <Link id="webinars-learn-more" to="/webinars-more">
//                     Learn More
//                 </Link>
//             </div>
            
//         </div>
//     )
// }

// const Content = styled(Content_)`
//     margin: 20px;
//     p {
//         margin: 0;
//     }
//     .right {
//         text-align: right;
//         padding: 10px 20px;
//     }
    
// `

// export default Content